import React, { useEffect } from "react";
import * as All from "react-icons/md/index";
export default function Icon(props) {
  const SelectedIcon = All[props.block.props.icon];

  if (!SelectedIcon) {
    return (
      <div
        ref={props.editorRef}
        style={{
          position: "relative",
          backgroundColor: props.block.props.backgroundColor,
          flexGrow: props.block.props.flexGrow,
          boxShadow: props.block.props.boxShadow,
          ...props.block.props.size,
          ...props.block.props.border,
          ...props.block.props.spacing,
        }}
      ></div>
    );
  }
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: props.block.props.backgroundColor,
        flexGrow: props.block.props.flexGrow,
        boxShadow: props.block.props.boxShadow,
        width: props.block.props.iconSize,
        height: props.block.props.iconSize,
        color: props.block.props.color,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
      }}
      ref={props.editorRef}
    >
      <SelectedIcon style={{ width: "100%", height: "100%" }} />
    </div>
  );
}
